import type { ReactElement } from 'react';

import { Grid, Text, useTheme } from '@simplywallst/ui-core';

import type { CurrencyISO } from '@/constants/currencies';
import { formatterCurrency } from '@/utilities/format';
import { NarrativeFairValueType } from '../../types';

export interface Props {
  currencyISO: CurrencyISO;
  icon: ReactElement;
  type?: NarrativeFairValueType;
  value: number | null;
}

const FairValue = ({ currencyISO, icon, type, value }: Props) => {
  const theme = useTheme();
  const isUserDefined = type === 'user_defined' || type === 'legacy';

  return (
    <>
      <Grid
        alignContent="center"
        justifyContent="center"
        height={theme.x3}
        width={theme.x3}
        borderRadius="x3"
        backgroundColor={isUserDefined ? 'darkGray' : 'darkerGray'}
        boxShadow={isUserDefined ? 'strongBorder' : undefined}
      >
        {icon}
      </Grid>
      <Text
        as="span"
        typography="xSmall"
        color={isUserDefined ? 'white' : 'mediumGray'}
      >
        {formatterCurrency(value, currencyISO)}
      </Text>
    </>
  );
};

export default FairValue;
